document.addEventListener("DOMContentLoaded", function () {
  console.log("🚀 Zusatzartikel-Karussell wird geladen...");

  let carouselContainer = document.getElementById("product-addon-carousel");
  if (!carouselContainer) {
    console.error("❌ Fehler: Karussell-Container nicht gefunden!");
    return;
  }

  let addonProducts = [
    { id: "51215942615367", handle: "individuelle-grusskarte", title: "Grußkarte", textfield: true },
    { id: "51313404051783", handle: "lindt-pralinen", title: "Lindt Pralinen (+8,95€)", textfield: false },
    { id: "51436887048519", handle: "fruchtsecco-erdbeer-alkoholfrei0-75-l", title: "Erdbeersecco - alkoholfrei (+6,90€)", textfield: false },
  ];

  let currentIndex = 0;
  let selectedAddons = new Set();
  let selectedVariants = {}; // Variantenspeicher

  let mainProductForm = document.querySelector("form[action='/cart/add']");
  let addToCartButton = document.querySelector("button[name='add']");
  let cartNotification = document.getElementById("cart-notification");
  let cartIcon = document.querySelector(".header__icon--cart");

  if (!mainProductForm || !addToCartButton) {
    console.error("❌ Fehler: Hauptprodukt-Formular oder 'In den Warenkorb' Button nicht gefunden!");
    return;
  }

  carouselContainer.innerHTML = `
    <div class="addon-carousel">
    <h3 class="addon-heading">Zusatzartikel</h3>
      <div class="addon-carousel-inner">
        <button id="prev-addon" class="carousel-btn">&lt;</button>
        <div class="addon-slider">
          <div class="addon-item" id="addon-item">
            <div id="addon-product-image" class="addon-product-image-container">
              <div class="addon-image-label">Hier auswählen</div>
            </div>
            <div class="addon-title" id="addon-title"></div>
            <select id="addon-variant" class="addon-variant-select" style="display: none;"></select>
            <textarea id="addon-text" class="addon-text" placeholder="Dein Wunschtext (optional)"></textarea>
            <div class="addon-selected-text" id="addon-selected-text" style="display: none;">✔ Ausgewählt</div>
          </div>
        </div>
        <button id="next-addon" class="carousel-btn">&gt;</button>
      </div>
    </div>
    <div id="addon-summary" class="addon-summary"></div>`;

  function updateAddonDisplay() {
    let product = addonProducts[currentIndex];
    let addonItem = document.getElementById("addon-item");
    let addonSelectedText = document.getElementById("addon-selected-text");

    document.getElementById("addon-title").textContent = product.title;
    addonItem.dataset.id = product.id;
    document.getElementById("addon-text").style.display = product.textfield ? "block" : "none";

    let isSelected = selectedAddons.has(product.id);
    addonItem.classList.toggle("selected", isSelected);
    addonSelectedText.style.display = isSelected ? "block" : "none";

    fetchAddonProductData(product);
    updateAddonSummary();
  }

  document.getElementById("prev-addon").addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + addonProducts.length) % addonProducts.length;
    updateAddonDisplay();
  });

  document.getElementById("next-addon").addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % addonProducts.length;
    updateAddonDisplay();
  });

  document.getElementById("addon-item").addEventListener("click", function (event) {
    if (["TEXTAREA", "INPUT", "SELECT"].includes(event.target.tagName)) return;

    let product = addonProducts[currentIndex];
    if (selectedAddons.has(product.id)) {
      selectedAddons.delete(product.id);
    } else {
      selectedAddons.add(product.id);
    }
    updateAddonDisplay();
  });

  function fetchAddonProductData(product) {
  fetch(`/products/${product.handle}.js`)
    .then(response => response.json())
    .then(data => {
      const imageContainer = document.getElementById("addon-product-image");
      const variantSelect = document.getElementById("addon-variant");
      const textArea = document.getElementById("addon-text");

      // 🖼 Bild anzeigen
      if (data.images.length > 0) {
  imageContainer.innerHTML = `
    <img src="${data.images[0]}" alt="Zusatzartikel" class="addon-product-image">
    <div class="addon-image-label">Hier auswählen</div>
  `;
}

      // 💾 Bereits gewählte Variante merken
      let savedVariantId = selectedVariants[product.id];

      // Varianten anzeigen
      if (data.variants.length > 1) {
        variantSelect.innerHTML = "";
        variantSelect.style.display = "block";

        data.variants.forEach(variant => {
          const option = document.createElement("option");
          option.value = variant.id;
          option.text = variant.title;

          // 🎯 Auswahl merken oder erste setzen
          if (
            savedVariantId &&
            savedVariantId.toString() === variant.id.toString()
          ) {
            option.selected = true;
          }

          variantSelect.appendChild(option);
        });

        // Falls keine Auswahl gespeichert war, erste Variante speichern
        if (!savedVariantId) {
          savedVariantId = data.variants[0].id;
        }

        selectedVariants[product.id] = variantSelect.value;

        variantSelect.onchange = () => {
          selectedVariants[product.id] = variantSelect.value;
          selectedAddons.add(product.id);
          
          // Kein updateAddonDisplay(), sonst würde alles zurückgesetzt!
          document.getElementById("addon-item").classList.add("selected");
          document.getElementById("addon-selected-text").style.display = "block";

          // Nur Textfeld anzeigen, wenn textfield aktiv
          textArea.style.display = product.textfield ? "block" : "none";

          updateAddonSummary();
        };
      } else {
        variantSelect.style.display = "none";
        selectedVariants[product.id] = data.variants[0].id;
      }

      // 📝 Textfeld anzeigen nur bei Auswahl
      textArea.style.display =
        product.textfield && selectedAddons.has(product.id)
          ? "block"
          : "none";
    })
    .catch(err => console.error("❌ Fehler beim Laden der Produktdaten:", err));
}




  let startX = 0;
  let endX = 0;
  let slider = document.querySelector(".addon-slider");

  slider.addEventListener("touchstart", (event) => {
    startX = event.touches[0].clientX;
  });

  slider.addEventListener("touchend", (event) => {
    endX = event.changedTouches[0].clientX;
    handleSwipe();
  });

  function updateAddonSummary() {
  const summaryContainer = document.getElementById("addon-summary");
  if (!summaryContainer) return;

  // Hauptprodukt-Titel holen
  const mainProductTitleElement = document.querySelector(".product__title h1");
  const mainProductTitle = mainProductTitleElement ? mainProductTitleElement.textContent.trim() : "Hauptprodukt";

  let html = `<strong>Deine Auswahl:</strong><br>`;
  html += `<em>Produkt:</em> ${mainProductTitle}<br>`;
  
  if (selectedAddons.size === 0) {
    html += `<em>Zusatzartikel:</em> Kein Zusatzprodukt ausgewählt.`;
  } else {
    html += `<em>Zusatzartikel:</em><ul>`;
    selectedAddons.forEach(addonId => {
      const product = addonProducts.find(p => p.id === addonId);
      if (!product) return;

      const variantId = selectedVariants[addonId];
      const variantElement = document.querySelector("#addon-variant");
      let variantLabel = "";

      if (variantElement && variantElement.options.length > 0) {
        const selectedOption = [...variantElement.options].find(opt => opt.value == variantId);
        variantLabel = selectedOption ? ` – ${selectedOption.text}` : "";
      }

      html += `<li>${product.title}${variantLabel}</li>`;
    });
    html += `</ul>`;
  }

  summaryContainer.innerHTML = html;
}




  function handleSwipe() {
    let diff = startX - endX;
    if (diff > 50) {
      currentIndex = (currentIndex + 1) % addonProducts.length;
    } else if (diff < -50) {
      currentIndex = (currentIndex - 1 + addonProducts.length) % addonProducts.length;
    }
    updateAddonDisplay();
  }

  addToCartButton.addEventListener("click", async function (event) {
    event.preventDefault();

    for (let addonId of selectedAddons) {
      let product = addonProducts.find(p => p.id === addonId);
      let properties = {};
      if (product.textfield) {
        let textInput = document.getElementById("addon-text").value.trim();
        if (textInput.length > 0) {
          properties["Wunschtext"] = textInput;
        }
      }
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: selectedVariants[addonId] || addonId,
          quantity: 1,
          properties: properties
        })
      });
    }

    let mainProductData = new FormData(mainProductForm);
    let jsonData = {};
    mainProductData.forEach((value, key) => {
      jsonData[key] = value;
    });

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(jsonData)
    });

    if (cartNotification) {
      cartNotification.classList.add("active");
      cartNotification.setAttribute("aria-modal", "true");
      cartNotification.setAttribute("role", "dialog");
      cartNotification.setAttribute("tabindex", "-1");
      if (cartIcon) cartIcon.classList.add("cart-updated");
    } else {
      window.location.href = "/cart";
    }
  });

  updateAddonDisplay();
});
